import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Reveal, MaskedLine } from "../components/Reveal";

export default function VerificaEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ loading: true, ok: false, message: "" });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, message: "Link non valido: manca il codice di verifica." });
      return;
    }
    api.post("/auth/verify-email", { token })
      .then((res) => setState({ loading: false, ok: true, message: res.data.message }))
      .catch((err) => setState({ loading: false, ok: false, message: formatApiError(err, "Verifica non riuscita.") }));
  }, [token]);

  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24 lg:py-32" data-testid="verifica-email-page">
      <div className="max-w-xl mx-auto text-center">
        <MaskedLine delay={0.1}><span className="eyebrow justify-center">Verifica email</span></MaskedLine>
        <h1 className="mt-6 text-4xl sm:text-5xl leading-tight" data-testid="verifica-title">
          <MaskedLine delay={0.25}>
            {state.loading ? "Verifica in corso…" : state.ok ? <>Email <em className="italic text-gold">confermata</em>.</> : <>Qualcosa non ha <em className="italic text-gold">funzionato</em>.</>}
          </MaskedLine>
        </h1>
        <Reveal delay={0.35}>
          <div className="mt-10 card-surface p-8 sm:p-10" data-testid="verifica-result">
            <p className="text-lg text-ink-muted leading-relaxed">{state.message}</p>
            {!state.loading && (
              <Link to="/accedi" className="btn-primary mt-8" data-testid="verifica-cta">
                Vai all'accesso
              </Link>
            )}
          </div>
        </Reveal>
      </div>
    </div>
  );
}
